import { Tabs, Tab, withStyles, WithStyles, Theme, Box, Badge } from '@material-ui/core'
import i18next from 'i18next'
import { Apartment } from '../../../types/apartments'
//import { FC } from 'react'

const styles = ({ breakpoints, spacing }: Theme) => ({
  container: {
    'box-sizing': 'border-box',
    width: '100%',
    padding: '0.3rem',
    background: '#F3F4F6',
    borderRadius: '7px'
  },
  selected: {
    background: '#ffffff !important',
    borderRadius: '7px',
    border: '1px solid #C3C6D1',
    color: '#49CC5B !important',
    margin: '0px',
    padding: '0px',
    height: '40px !important',
    'box-sizing': 'border-box'
  },
  tab: {
    height: '40px !important',
    margin: '0px',
    padding: '0px'
  },
  badge: {
    transform: 'translate(17px, -6px)',
    '@media (max-width:440px)': {
      transform: 'translate(12px, -7px)',
    },
    '@media (max-width:400px)': {
      transform: 'translate(11px, -7px)',
    },
    '& .MuiBadge-dot': {
      backgroundColor: 'rgb(73, 204, 91) !important',
    },
    '& .MuiBadge-colorPrimary': {
      backgroundColor: 'rgb(73, 204, 91) !important',
      color: '#fff !important',
    },
  },
  labelFontSize: {
    '@media (max-width:400px)': {
      fontSize: '12px',
    },
    '@media (max-width:360px)': {
      fontSize: '11px',
    },
  },
})

interface UserApartmentsTabsProps extends WithStyles {
  currentTab: 'draft' | 'marketing' | 'rented'
  setCurrentTab: React.Dispatch<
    React.SetStateAction<'draft' | 'marketing' | 'rented'>
  >
  t: i18next.TFunction,
  apartments: Apartment[]
}

const UserApartmentsTabs = ({
  setCurrentTab,
  currentTab,
  t,
  classes,
  apartments
}: UserApartmentsTabsProps) => (
  <div className={classes.container}>
    <Tabs
      value={currentTab}
      indicatorColor='primary'
      textColor='primary'
      onChange={(event, value) => setCurrentTab(value)}
      aria-label='received and rejected tabs'
      variant='fullWidth'
    >
      <Tab
        label={
          <Box position="relative">
            <span className={classes.labelFontSize}>{t('apartments.tabs.draft')}</span>
            <Badge
              showZero
              badgeContent={apartments.filter(apartment => apartment.status === 'confirmed' || apartment.status === 'created').length}
              color="primary"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.badge}
            />
          </Box>
        }
        value='draft'
        className={currentTab === 'draft' ? classes.selected : classes.tab}
      />
      <Tab
        label={
          <Box position="relative">
            <span className={classes.labelFontSize}>{t('apartments.tabs.marketing')}</span>
            <Badge
              showZero
              badgeContent={apartments.filter(apartment => apartment.status === 'marketing' || apartment.status === 'followUp').length}
              color="primary"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.badge}
            />
          </Box>
        }
        value='marketing'
        className={currentTab === 'marketing' ? classes.selected : classes.tab}
      />
      <Tab
        label={
          <Box position="relative">
            <span className={classes.labelFontSize}>{t('apartments.tabs.rented')}</span>
            <Badge
              showZero
              badgeContent={apartments.filter(apartment => apartment.status === 'rented' || apartment.status === 'cancelled').length}
              color="primary"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.badge}
            />
          </Box>
        }
        value='rented'
        className={currentTab === 'rented' ? classes.selected : classes.tab}
      />
    </Tabs>
  </div>
)

export default withStyles(styles)(UserApartmentsTabs)
